/**
 * Utility functions for archaeology by book data
 */

/**
 * Sort archaeology by book alphabetically by book name
 */
export function sortArchaeologyByBook(
  items: ArchaeologyByBook[]
): ArchaeologyByBook[] {
  return [...items].sort((a, b) => (a.book || '').localeCompare(b.book || ''));
}

/**
 * Get archaeology by book data by book name
 */
export function getArchaeologyByBookByBook(
  items: ArchaeologyByBook[],
  book: string
): ArchaeologyByBook | undefined {
  return items.find(item => item.book === book);
}

/**
 * Filter archaeological findings by importance level
 */
export function filterFindingsByImportance(
  findings: ArchaeologyByBook['findings'],
  importance: Importance
): ArchaeologyByBook['findings'] {
  return findings?.filter(finding => finding.importance === importance) || [];
}

/**
 * Get high importance findings from book data
 */
export function getHighImportanceFindingsFromBook(
  archaeologyByBook: ArchaeologyByBook | undefined
): ArchaeologyByBook['findings'] {
  if (!archaeologyByBook) {
    return [];
  }

  return archaeologyByBook.findings?.filter(f => f.importance === 'high') || [];
}

